import Header from '../components/Header/Header.js';
import { connect } from 'react-redux';
import { redux as apiRedux } from '../api';
const { setUserInfo, setSoundState, setMenuCollapsed } = apiRedux.actions;

const mapStateToProps = state => {
  return {
    userInfo: state.api.user.info,
    newTaskState: state.api.current.newTaskState,
    soundState: state.api.current.soundState,
    changeMenuTaskFlag: state.api.current.changeMenuTaskFlag,
    menuCollapsed: state.api.current.menuCollapsed,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onUserInfoUpdated: user => dispatch(setUserInfo(user)),
    setSoundState: data => dispatch(setSoundState(data)),
    setMenuCollapsedData: data => dispatch(setMenuCollapsed(data)),
  };
};

const ConnectedHeader = connect(
  mapStateToProps,
  mapDispatchToProps
)(Header);

export default ConnectedHeader;
